module.exports = __webpack_public_path__ + "static/img/tabbar_order_normal@2x.c659599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar_order_normal@2x.png
// module id = JEv4
// module chunks = 1